export default {
  index: {
    text1: 'Sign In',
    text2: 'Sign In',
    text3: 'Forgot Password',
    text4: 'Reset Password',
    text5: 'Register',
    text6: 'Phone No./Email',
    text7: 'Password'
  },
  forgetPassword: {
    text1: 'Change Password',
    text2: 'Return Sign In',
    text3: 'Verification of identity',
    text4: 'Reset Password',
    text5: 'Reset Successfully',
    text6: 'Phone No.',
    text7: 'Verification Code',
    text8: 'Reset Password',
    text9: 'Confirm the password',
    text10: 'Your password has been reset.',
    text11: 'return to sign in page.',
    text12: 'Return logon'
  },
  register: {
    text1: 'Register',
    text2: 'Sign in',
    text3: 'NCIC Curriculum Home',
    text4: 'Verify Phone No.',
    text5: 'Enter Account Info.',
    text6: 'Register Successfully',
    formtext1: 'Phone No.',
    formtext2: 'Verification code',
    formtext3: 'Email',
    formtext4: 'Set password ',
    formtext5: 'Confirm password',
    formtext6: 'Nationality',
    formtext66: 'Please choose',
    formtext7: 'First name',
    formtext8: 'Middle name',
    formtext9: 'Last name',
    formtext10: 'Full name',
    formtext11: 'Gender',
    indexReg1: 'Your account has been registered!',
    indexReg2: 'Welcome to',
    indexReg3: 'NCIC course',
    indexReg4: ' seconds later it will jump to login.'
  },
  lookup: {
    title: 'Base Data List',
    lookupId: 'ID',
    lookupCode: 'Code',
    orgId: 'Organization ID',
    lookupName: 'Name',
    lookupNameZh: 'Name-CN',
    lookupNameEn: 'Name-EN',
    lookupDesc: 'Description',
    update: 'Edit Data',
    create: 'Crate Data'
  },
  lookupItem: {
    title: 'Base DataItems List',
    lookupId: 'Data ID',
    lookupItemId: 'DataItem ID',
    lookupItemOrder: 'Order',
    lookupItemCode: 'Code',
    lookupItemName: 'Name',
    lookupItemNameZh: 'Name-CN',
    lookupItemNameEn: 'Name-EN',
    lookupItemDesc: 'Description',
    update: 'Edit DataItems',
    create: 'Create DataItems'
  },
  subjects: {
    subjectName: 'Please fill in the Subject Name'
  },
  course: {
    schoolId: 'Please select school',
    subjectId: 'Please select subject',
    gradeId: 'Please select grade',
    courseId: 'Please select course or fill in the Course Name',
    courseName: 'Please fill in the Course Name'
  },
  methods: {
    methodName: 'Please fill in the Method Name'
  },
  types: {
    typeName: 'Please fill in the Type Name'
  },
  standard: {
    subjectId: 'Please select subject',
    standardId: 'Please select standard',
    standardName: 'Please select Standard or fill in the Standard Name',
    versionName: 'Please fill in the Version Name',
    fileName: 'Please upload file'
  },
  academicYear: {
    yearName: 'Please fill in the Year Name',
    date: 'Please select date'
  },
  schools: {
    schoolName: 'Please fill in the School Name'
  },
  grades: {
    gradeName: 'Please fill in the Grade Name'
  },
  mapTypes: {
    mapCode: 'Please fill in the Map Code',
    mapName: 'Please fill in the Map Name'
  }
}



// WEBPACK FOOTER //
// ./src/views/admin/lang/en.js